import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-offer-petal',
  templateUrl: './offer-petal.component.html',
  styleUrls: ['./offer-petal.component.scss'],
})
export class OfferPetalComponent {
  @Input() offerText = '';
  @Input() primeTextDiscount = '';
  @Input() description = '';
  @Input() isMobile = false;
  @Input() group = '';
  @Input() suggestCard = false;
  @Input() isSuggest = false;
  @Input() showTagOffer = false;
  @Input() showTagOfferPrime = false;
  @Input() onlyOnline = false;
  @Input() detailDescription = '';
  @Input() isHalf = false;
  @Input() noPrimePetal = false;

  get isMobileGroup() {
    return this.isMobile && this.group;
  }

  get groupClass() {
    return this.group === 'suggests' && this.isMobile ? 'suggests' : null
  }

  get altText() {
    return `Descuento de ${this.offerText} en ${this.description} ${this.detailDescription}`;
  }
}
